import * as React from 'react';
import { Accordion, Card, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { createQuoteFromPolicy, initiateCodeRedSteps, setQuoteType, setStep } from '../../../actions/salesActions';
import { CODE_RED_VIEW_BUILDER, DASHBOARD, SEE_AVAILABLE_AREAS } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import './GetCodeRed.css';
import { PRODUCT_COMPREHENSIVE_CAR } from '../../../constants/constants';
import { refreshCart } from '../../../actions/cartActions';
import FAQItem from '../../FAQ/FAQItem';
import { logEvent } from '../../../firebase/firebase';

class GetCodeRed extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loggedIn: this.props.auth.uid ? true : false,
            accordionActiveKey: 0
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleShowComingSoon = this.handleShowComingSoon.bind(this);
    }

    componentWillMount() {
        logEvent('SSP_get_code_red_landed', 'user_landed_on_get_code_red');
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleShowComingSoon() {
        this.props.dispatchShowComingSoon();
    }

    async handleRedirect() {
        logEvent('SSP_get_code_red_add_to_quote', 'user_cliked_get_a_quote_code_red');
        var nextPage = CODE_RED_VIEW_BUILDER;
        if (this.props.profile.policyId === "" && this.props.sales.quoteId === "") {
            await this.props.dispatchAction(initiateCodeRedSteps());
            await this.props.redirectTo(nextPage);
        }
        else if (this.props.profile.policyId !== "" && this.props.sales.quoteId === "") {
            await this.props.dispatchAction(createQuoteFromPolicy());
            if (this.props.sales.quoteId !== "") {
                await this.props.dispatchAction(refreshCart());
                await this.props.dispatchAction(initiateCodeRedSteps());
                await this.props.redirectTo(nextPage);
                await this.props.dispatchAction(setStep(3,1));
            }
        }
        else {
            await this.props.dispatchAction(initiateCodeRedSteps());
            await this.props.redirectTo(nextPage);
            await this.props.dispatchAction(setStep(3,1));
        }
    }
    
    faqSet: any[] = [{
        header: "Which response partner does King Price use",
        body: "<p class='mb-0'>We’ve partnered with Secura, a PSIRA-registered (Private Security Industry Regulatory Authority) armed response network.</p>",
        id: 1
    },
    {
        header: "When will I have access to code red",
        body: "<p class='mb-0'>You’ll have access to code red once you’ve downloaded our app, registered for code red, accepted our T’s & C’s and paid your first monthly or pro rata premium.</p>",
        id: 2
    },
    {
        header: "Can my family use code red",
        body: "<p class='mb-0'>Unfortunately not… For now, only the policyholder is covered, but we’re working on extending this cover to members of your household.</p>",
        id: 3
    },
    {
        header: "How many times a year can I use this feature",
        body: "<p class='mb-0'>You can activate code red as many times as you need to, provided that you don’t abuse the service.</p>",
        id: 4
    },
    {
        header: "Can I use code red when I’m in another country",
        body: "<p>Nope, code red is only available in South Africa. You’re covered in all major metros and sub-metros and many outlying areas. It’s your responsibility to familiarise yourself with these areas, and you can do so by clicking <a class='codeRedLink' href='" + SEE_AVAILABLE_AREAS + "' target='_blank'>here</a>.</p><br/>" +
            "<p class='mb-0'>If you’re outside the scope of our response network (in SA) we’ll let your local police know so that they can help you.</p>",
        id: 5
    },
    {
        header: "How will my location be used",
        body: "<p class='mb-0'>We’ll only use your location for lawful and valid reasons, to provide code red services to you. We also store this info in a secure storage database, so your location is completely safe with us.</p>",
        id: 6
    },
    {
        header: "Does King Price cover all emergency responders’ costs",
        body: "<p class='mb-0'>You’re not covered for any costs charged by any emergency service that’s dispatched as a result of you activating code red.</p>",
        id: 7
    },
    {
        header: "Can I use free SMSs to activate code red",
        body: "<p class='mb-15px'>You must have data on your phone, and this is for your account. Your service provider’s standard data rates will apply.</p>",
        id: 8
    },
    {
        header: "Our T’s and C’s",
        body: "<ul>"+
			"<li>Click <a className='codeRedLink' target='_blank' href='https://www.kingprice.co.za/terms-and-conditions/'>here</a> for the full code red T’s and C’s.</li>"+
			"<li class='mt-15px'>Code red aims to provide support, if possible, in circumstances where you feel physically threatened. It isn’t intended to reduce any physical threat to you and shouldn’t be viewed as a preventative measure.</li>"+
			"<li class='mt-15px'>Response times, or access to and availability of responding vehicles and services aren’t guaranteed.</li>"+
			"<li class='mt-15px'>You agree that we can collect, store and analyse data arising from your use of code red. Location data from your cellphone will be gathered and securely transmitted to our data storage facility, where it’ll be securely stored. This data will be used for lawful and valid reasons, primarily to provide code red services to you.</li>"+
			"<li class='mt-15px'>Our code red partner and the entity providing the code red service is a company called Secura, a representative of a network of hundreds of armed response companies who are all registered with PSIRA (the Private Security Industry Regulatory Authority).</li>"+
			"</ul>",
        id: 9
    },
    ];

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]

        let faq;
        if (this.faqSet) {
            faq = this.faqSet.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={this.state.accordionActiveKey} />
                }
            });
        }

        return (
            <div className={this.state.loggedIn ? "logged-in" : "logged-out"}>
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Get code red" />
                <div className="row new-page-main-row justify-content-center">
                    {/* Banner */}
                    <div className="col-12">
                        <div className="get-code-red-banner">
                            <div className="get-code-red-banner-content-left">
                                <div className="get-code-red-banner-content-image">
                                    <img alt="" title="" src="./Images/CodeRed/icon-code-red.svg" />
                                </div>
                                <div className="get-code-red-banner-content-detail">
                                    <div className="get-code-red-banner-content-detail-title">
                                        Code red
                                    </div>
                                    <div className="get-code-red-banner-content-detail-text">
                                        Peace of mind for when you feel unsafe, or when there’s a medical emergency
                                    </div>
                                </div>
                            </div>
                            <div className="get-code-red-banner-content-right">
                                <div className="text-center" style={{width:"100%"}}>
                                    <div className="get-code-red-banner-content-premium-title">
                                        Only R 25 per month
                                    </div>
                                    <button className="btn btn-solid-green mt-16px" onClick={this.handleRedirect}>Get a quote</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6 px-lg-3 pl-0 mb-3 mt-3 mt-lg-0 mobile-ml-16px">
                        {/*Benefits*/}
                        <div id="CodeRedBenifits" className="accordion-arrow">
                            <h3 className="ml-20px">Code red benefits</h3>

                            <div className="">
                                <div className="col-12 mb-2 new-benefits-col">
                                    <div className="icon-checkmark-circle-32px"></div>&nbsp; 24/7 assistance
                                </div>
                                <div className="col-12 mb-2 new-benefits-col">
                                    <div className="icon-checkmark-circle-32px"></div>&nbsp; Instant response
                                </div>
                                <div className="col-12 mb-2 new-benefits-col">
                                    <div className="icon-checkmark-circle-32px"></div>&nbsp; Cover in all major/sub-metros
                                </div>
                            </div>

                        </div>

                        {/*Where am I covered*/}
                        <div id="Covered" className="mt-3">
                            <h3>Where am I covered</h3>
                            <p className="font-size-14px">You’re covered in all major metros and sub-metros and many outlying areas. For more info on our response network click below:</p>

                            <a href="https://docs.aura.services/hosted-coverage-map.html" target="_blank">
                                <button id="CoveredId" className="btn btn-outline-red">View our response network</button>
                            </a>
                        </div>
                    </div>

                    {/*Dynamic FAQ Accordian*/}
                    <div className="col-12 col-lg-6 submit-a-claim-history-col-1">
                        <div className="code-red-faq-holder">
                            <h3 className="text-red">FAQs</h3>
                            <div className="new-ssp-code-red-faq-block code-red-accordion-holder">
                                <Accordion onSelect={(e) => this.setState({ accordionActiveKey: Number(e) })}>
                                    {faq}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile,
        auth: state.firebase.auth,
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetQuoteType: () => dispatch(setQuoteType(PRODUCT_COMPREHENSIVE_CAR)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GetCodeRed);